import BookingListComponent from "../components/booking-list.component";

const BookingList = () => {
    return <BookingListComponent />;
  };
  
  export default BookingList;